import React, { useState } from "react";
import { Radio, Card, Row, Col } from "antd";
import RackRate from "./RackRate/index";
import EndorseCalc from "./EndorseCal/EndorseCalc";
import EndorseList from "./EndorseCal/index";
import EndorseRackRatePolicyList from "./RackRate/EndorseRackRatePolicyList";
import { useSelector } from "react-redux";
import { getUserData } from "../login/LoginSlice";

const claimOptions = [
  { value: 1, label: "Rack Rates List", optionId: 21 },
  { value: 2, label: "Endorsement Calculation", optionId: 22 },
  { value: 3, label: "Endorsement Calculation List", optionId: 23 },
];

const Index = () => {
  const [activeComponent, setActiveComponent] = useState(1);
  const [heading, setHeading] = useState("Rack Rates List");
  const Data = useSelector(getUserData);

  const userModule = Data?.module_data?.find((module) => module.module_id === 13);
  const userOptionIds = userModule?.module_option_ids || [];
  console.log("Allowed Option IDs:", userOptionIds);

  const setActiveTab = (componentValue) => {
    setActiveComponent(componentValue);
    setHeading(claimOptions.find((option) => option.value === componentValue)?.label || "Rack Rates List");
  };

  const handleComponentChange = (e) => {
    setActiveTab(e.target.value);
  };

  return (
    <div>
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            className="cust-cd-card mb-3"
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                <span className="corp-title">{heading}</span>

                <Radio.Group
                  block
                  onChange={handleComponentChange}
                  value={activeComponent} // Use value for controlled component
                  buttonStyle="solid"
                  optionType="button"
                >
                  {claimOptions.map(({ value, label, optionId }) => (
                    <Radio
                      key={value}
                      value={value}
                      disabled={!userOptionIds.includes(optionId)}
                    >
                      {label}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            }
            bordered={false}
          ></Card>

          {activeComponent === 1 && <RackRate />}
          {activeComponent === 2 && <EndorseCalc />}
          {activeComponent === 3 && <EndorseList onAddEndorsement={() => setActiveTab(2)} />}
        </Col>
      </Row>
    </div>
  );
};

export default Index;